import React from 'react'
import { get, uniqBy } from 'lodash'

function BrandReportsDisplay(record, column) {
  const brands = uniqBy(get(record, column.key, []), (carrierBrand) => { return carrierBrand.name })
  const rows = brands.map((carrierBrand, i) => (
    <div key={i}>{carrierBrand.name}</div>
  ))

  return (
    <div>
      {rows}
    </div>
  )
}

export default BrandReportsDisplay
